import {
  MlsListingSubType,
  MlsListingType,
  UsState,
} from '@client/graphql/__generated__/types';

export interface OffMarketListingFormData {
  streetAddress: string;
  city: string;
  state?: UsState;
  zipCode: string;
  unit?: string;
  targetPrice: number;
  squareFootage: number;
  yearBuilt: number;
  bedrooms: number;
  fullBaths: number;
  halfBaths: number;
  propertyType: MlsListingType;
  propertySubtype: MlsListingSubType;
  subdivision: string;
  schoolDistrict: string;
}

export const INITIAL_VALUES: Partial<OffMarketListingFormData> = {
  streetAddress: '',
  city: '',
  zipCode: '',
  unit: '',
  subdivision: '',
  schoolDistrict: '',
};

export const FIELD_TO_LABEL_MAP = {
  streetAddress: 'Address',
  city: 'City',
  state: 'State',
  zipCode: 'Zip Code',
  unit: 'Unit',
  subdivision: 'Subdivision',
  schoolDistrict: 'School District',
  targetPrice: 'Target Price',
  squareFootage: 'Square Footage',
  yearBuilt: 'Year Built',
  bedrooms: 'Bedrooms',
  fullBaths: 'Full Baths',
  halfBaths: 'Half Baths',
  propertyType: 'Property Type',
  propertySubtype: 'Property Subtype',
};

export const REQUIRED_ADDRESS_FIELDS = [
  'streetAddress',
  'city',
  'state',
  'zipCode',
];
export const REQUIRED_DETAILS_FIELDS = [
  ...REQUIRED_ADDRESS_FIELDS,
  'targetPrice',
  'squareFootage',
  'yearBuilt',
  'bedrooms',
  'fullBaths',
  'propertyType',
  'propertySubtype',
];

export enum AddOffMarketListingStep {
  ADDRESS = 'ADDRESS',
  DETAILS = 'DETAILS',
}
